"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

require("../../assets/css/components/button/ActionButton.css");

var _Icone = require("../elements/Icone");

var _Icone2 = _interopRequireDefault(_Icone);

var _reactRouter = require("react-router");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ActionButton = function (_React$Component) {
    _inherits(ActionButton, _React$Component);

    function ActionButton(props) {
        _classCallCheck(this, ActionButton);

        var _this = _possibleConstructorReturn(this, (ActionButton.__proto__ || Object.getPrototypeOf(ActionButton)).call(this, props));

        _this.state = {
            displayMenu: false
        };
        _this.displayMenu = _this.displayMenu.bind(_this);
        _this.hideMenu = _this.hideMenu.bind(_this);
        return _this;
    }

    _createClass(ActionButton, [{
        key: "displayMenu",
        value: function displayMenu(event) {
            event.preventDefault();
            this.setState(function (prevState, props) {
                return { displayMenu: !prevState.displayMenu };
            });
        }
    }, {
        key: "hideMenu",
        value: function hideMenu() {
            this.setState({ displayMenu: false });
        }
    }, {
        key: "hideContent",
        value: function hideContent() {
            if (this.state.displayMenu && this.props.children) return _react2.default.createElement("div", { className: "hide-content", onClick: this.hideMenu, "aria-hidden": "true" });
        }
    }, {
        key: "getColor",
        value: function getColor() {
            return this.props.color ? this.props.color : "primary";
        }
    }, {
        key: "getButton",
        value: function getButton() {
            if (this.props.children) {
                return _react2.default.createElement(
                    "li",
                    { className: "action-menu" },
                    _react2.default.createElement(
                        "a",
                        { href: "#",
                            className: "mdl-button mdl-button--fab primary btn-action" + (this.state.displayMenu ? " active" : ""),
                            onClick: this.displayMenu, "aria-haspopup": "true", "aria-expanded": this.state.displayMenu },
                        "Exibir menu",
                        _react2.default.createElement(_Icone2.default, { icone: "menu", important: true }),
                        _react2.default.createElement(_Icone2.default, { icone: "clear", important: true })
                    ),
                    _react2.default.createElement(
                        "ul",
                        { className: "action-submenu" + (this.state.displayMenu ? " action-submenu-open" : ""),
                            "aria-hidden": !this.state.displayMenu },
                        this.props.children
                    )
                );
            } else {
                return _react2.default.createElement(
                    "li",
                    null,
                    _react2.default.createElement(
                        _reactRouter.Link,
                        { href: this.props.href, to: this.props.to, onClick: this.props.onClick,
                            className: "mdl-button mdl-button--fab btn-action " + (this.props.color ? this.props.color : "primary"),
                            "aria-label": this.props.label },
                        _react2.default.createElement(_Icone2.default, { icone: this.props.icon, tamanho: "1.7", important: true })
                    )
                );
            }
        }
    }, {
        key: "render",
        value: function render() {
            return _react2.default.createElement(
                "nav",
                { className: "action-button", "aria-label": "Menu de a\xE7\xF5es para p\xE1gina" },
                this.hideContent(),
                _react2.default.createElement(
                    "ul",
                    { className: "action-options" },
                    this.getButton()
                )
            );
        }
    }]);

    return ActionButton;
}(_react2.default.Component);

exports.default = ActionButton;


//////////////////
// WEBPACK FOOTER
// ../react-template/lib/components/button/ActionButton.js
// module id = 1101
// module chunks = 0